import { createApp } from 'vue'
import { createPinia } from 'pinia';
import App from './App.vue'
import router from "./router"
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import VueNumberInput from '@chenfengyuan/vue-number-input';
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import { createHead } from '@vueuse/head';

const toastOptions = {
    // You can set your default options here
};

// Versão atual gerada pelo webpack em tempo de build
// ou definida manualmente em variáveis de ambiente
const APP_VERSION = process.env.VUE_APP_VERSION || '1.0.0';

// Armazena a versão no localStorage para comparação
const storedVersion = localStorage.getItem('app_version');
if (storedVersion && storedVersion !== APP_VERSION) {
  // Versão diferente detectada, limpa cache e recarrega
  console.log(`Nova versão detectada: ${APP_VERSION}. Atualizando...`);
  
  // Limpa qualquer cache de serviço worker
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  }
  
  // Limpa cache de aplicação
  if ('caches' in window) {
    caches.keys().then(cacheNames => {
      cacheNames.forEach(cacheName => {
        caches.delete(cacheName);
      });
    });
  }
  
  // Força recarga da página ignorando cache
  window.location.reload(true);
}

// Armazena a versão atual
localStorage.setItem('app_version', APP_VERSION);

const head = createHead();

const app = createApp(App)
    .use(router)
    .use(createPinia())
    .use(Toast, toastOptions)
    .use(head)
    .component(VueNumberInput.name, VueNumberInput);
app.mount("#app");
